import React, { useState, useEffect } from "react";
import AtriumApi from "api";

/** Current conditions at the church's location; renders nothing until weather loads. */
const WeatherWidget = () => {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const churchRes = await AtriumApi.get("/v1/church");
        const coords = churchRes?.data?.church?.location?.coordinates;
        if (!coords || coords.length < 2) return;

        const [lon, lat] = coords;
        const res = await AtriumApi.get(`/v1/weather?lat=${lat}&lon=${lon}`);
        if (res?.data) setWeather(res.data);
      } catch {
        // Weather is decorative; the header simply omits it when unavailable.
      }
    };
    fetchWeather();
  }, []);

  if (!weather?.current) return null;

  return (
    <div className="flex items-center gap-2">
      <img
        src={weather.current.condition?.icon}
        alt=""
        className="h-10 w-10"
      />
      <div className="text-right">
        <p className="text-xl font-bold leading-none text-fg">
          {Math.round(weather.current.temp_f)}°F
        </p>
        <p className="mt-0.5 text-xs text-fg-muted">{weather.current.condition?.text}</p>
      </div>
    </div>
  );
};

export default WeatherWidget;
